 <script src="https://www.google.com/recaptcha/api.js"></script>

<template>
  <div class="p-0 container-fluid">
    <div class="g-0 row">
      <div class="col-xl-9">
        <div class="auth-full-bg pt-lg-5 p-4">
          <div class="w-100">
            <div class="bg-overlay"></div>
          </div>
        </div>
      </div>

      <div class="col-xl-3">
        <div class="auth-full-page-content p-md-5 p-4">
          <div class="w-100">
            <div class="d-flex flex-column h-100">
              <div class="mb-4 mb-md-5">
                <img
                  src="https://unicampo.coop.br/uploads/bkp/2022/portal/logo.png"
                  height="45"
                />
              </div>
              <div class="my-auto">
                <div>
                  <div>
                    <p class="text-muted">
                      Preencha o campo para que o e-mail de validação seja
                      reenviado:
                    </p>
                  </div>
                  <div>
                    <div class="mb-3">
                      <b-form-group class="mb-3" label="E-mail *">
                        <b-form-input
                          v-model="emailConfirm"
                          type="text"
                          autocomplete="off"
                          trim
                          placeholder="E-mail"
                        ></b-form-input>
                      </b-form-group>
                    </div>

                    <div class="row mb-0">
                      <div class="col-6 text-right">
                        <router-link to="/login">
                          <button
                            class="btn btn-secondary bg-soft w-md waves-effect waves-light"
                          >
                            Cancelar
                          </button>
                        </router-link>
                      </div>
                      <div class="col-6 text-end">
                        <button
                          @click="reenviarEmail()"
                          class="btn btn-primary w-md waves-effect waves-light"
                        >
                          Continuar <i class="far fa-arrow-alt-circle-right" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mt-4 text-center">
                  <ul class="list-inline">
                    <li class="list-inline-item">
                      <a
                        class="social-list-item bg-primary text-white border-primary"
                        href="https://pt-br.facebook.com/UNICAMPO/"
                        target="_blank"
                      >
                        <i class="mdi mdi-facebook"></i>
                      </a>
                    </li>
                    <li class="list-inline-item">
                      <a
                        class="social-list-item bg-danger bg-gradient text-white border-danger"
                        href="https://www.instagram.com/unicampo_coop"
                        target="_blank"
                      >
                        <i class="mdi mdi-instagram"></i>
                      </a>
                    </li>
                    <li class="list-inline-item">
                      <a
                        class="social-list-item bg-info text-white border-info"
                        href="https://br.linkedin.com/company/unicampo"
                        target="_blank"
                      >
                        <i class="mdi mdi-linkedin"></i>
                      </a>
                    </li>
                    <li class="list-inline-item">
                      <a
                        class="social-list-item bg-danger text-white border-danger"
                        href="https://www.youtube.com/channel/UCiskgZkQPOzT6i4AdY0JbAw"
                        target="_blank"
                      >
                        <i class="mdi mdi-youtube"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="mt-4 mt-md-5 text-center">
                <p class="mb-0">
                  © {{ new Date().getFullYear() }} UNICAMPO. Todos os direitos
                  Reservados.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VueRecaptcha } from "vue-recaptcha";
import emailCpf from "@/components/formulario/emailCpf-input";
import senha from "@/components/formulario/senha-input";
import { required } from "vuelidate/lib/validators";

export default {
  components: { emailCpf, senha, VueRecaptcha },
  layout: "empty",
  data() {
    return {
      alerta: false,
      showValidaEmail: true,
      emailConfirm: "",
    };
  },

  created() {},

  methods: {
    reenviarEmail() {
      this.$http
        .post("api/reenviarConfimacaoEmail", {
          email: this.emailConfirm,
        })
        .then((response) => {
          this.$tools.alerta("E-mail enviado com sucesso!", "success");
          this.showValidaEmail = true;
          this.alerta = false;
          this.$router.push("/login");
        })
        .catch((err) => {
          this.$tools.alerta(err.response.data.message, "error");
        });
    },
  },
};
</script>
